<template>
  <div>
    <label
      for="email"
      class="form-label placeholder-label relative w-full mt-3 text-base"
    >
      <input
        id="email"
        v-model.trim="validate.email.$model"
        type="email"
        class="form-control p-3"
        :class="{ 'border-theme-6': validate.email.$error }"
        placeholder=" "
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <span
        class="p-3 absolute opacity-50 left-0 top-0 transition-all duration-300 ease-in-out text-base"
        >Email</span
      >
    </label>
    <div
      v-for="error of validate.email.$errors"
      :key="error.$uid"
      class="input-errors"
    >
      <div class="error-msg text-theme-6 mt-2">
        {{ error.$message }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default defineComponent({
  props: {
    emailAddress: {
      type: String,
      default: () => {
        return "";
      },
      required: false
    },
    touch: {
      type: Boolean,
      required: false
    }
  },
  setup: () => ({ validate: useVuelidate() }),
  data() {
    return {
      email: this.emailAddress
    };
  },
  watch: {
    emailAddress: function(val) {
      if (val) {
        this.email = val;
      }
    },
    touch: function(val) {
      if (val) {
        this.validate.email.$touch();
      }
    }
  },
  validations() {
    return {
      email: { required, email }
    };
  }
});
</script>
